<template>
    <Link
        :href="route('posts.submitVideo.show', { post: post, competitor: $page.props.competitor.id })"
        v-bind="$attrs"
        class="focus:shadow-outline-gray duration-50 group relative inline-flex items-center place-content-center px-6 py-3 w-full text-white text-sm font-semibold tracking-wide disabled:bg-green-200 bg-green-500 hover:bg-green-700 active:bg-green-800 border border-transparent rounded-md focus:outline-none uppercase transition ease-in-out hover:ring-2 focus:ring-4 ring-green-500 ring-offset-2"
    >
        Upload Challenge Video
    </Link>
</template>

<script>
export default {
    props: {
        post: {
            required: true,
            type: Object,
        },
    },
}
</script>
